import React from 'react';
import { FeatureFlagProvider } from '@tradingblock/components';
import { useAuthenticationToken } from '../data/global/dataSelectors';
import Config from '../config';

/**
 * Wrapper component that provides feature flag context with auth token from Redux state.
 * Must be placed inside the Redux Provider.
 */
export const FeatureFlagWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authToken = useAuthenticationToken() || null;
  
  const baseUrl = Config.uiApi;

  return (
    <FeatureFlagProvider baseUrl={baseUrl} authToken={authToken}>
      {children}
    </FeatureFlagProvider>
  );
};

export default FeatureFlagWrapper;
